import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as BookIcon} from "assets/img/book.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function ComplianceItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_COMPLIANCE)) {
        return null;
    }

    return (
        <SidebarItem
            isTopLevel
            icon={<BookIcon />}
            to={MarketplaceRoutes.COMPLIANCE}
            selected={currentPath.startsWith(MarketplaceRoutes.COMPLIANCE)}
        >
            <FormattedMessage id='sidebar.item.compliance' />
        </SidebarItem>
    );
}

export default ComplianceItem;
